<template>
  <div class="questionnaireMain" style="width:100%; margin-bottom: 20px">
    <div style="border:none">
      <!-- 头部 -->
      <!-- 日期题 -->
      <div v-if="item.type == 'DateQuestion'">
        <div class="isTitle" v-if="item.value.dateAttribute.isTitle">
          <span v-html="item.value.dateAttribute.titleValue"></span>
        </div>
        <div class="data_title title_margin">
          <span
            v-if="item.value.dateAttribute.fill"
            style="position:relative; padding: 0 5px;"
            :class="{'star':item.value.dateAttribute.fill}"
          ></span>
          {{(parseInt(pindex) + 1) + '.'}}
          {{item.value.dateAttribute.name}}
          <!-- 文件附件 -->

          <file
            style="display:inline;"
            v-if="item.value.dateAttribute.imageUrls.length != '0'"
            :item="item"
          ></file>
        </div>
        <div class="info_message">{{item.value.dateAttribute.prompt}}</div>
        <datePick :item="item" :pindex="pindex"></datePick>
        <div class="data_content" style="position: relative;">
          <!-- <el-date-picker 
           :editable="false"  
           v-model="item.value.dateAttribute.answer"  
           @on-change="showDatePicker(item, pindex)" 
           placeholder="请选择日期" style="width: 200px">
          </el-date-picker>-->
        </div>
        <div
          class="parseValue"
          v-if="questionIsAnswer && item.value.dateAttribute.isParse"
        >{{item.value.dateAttribute.parseValue}}</div>
      </div>
      <!-- 时间题 -->
      <div class="time_select" v-if="item.type == 'TimeQuestion'">
        <div class="isTitle" v-if="item.value.timeAttribute.isTitle">
          <span v-html="item.value.timeAttribute.titleValue"></span>
        </div>
        <div class="time_title title_margin">
          <span
            v-if="item.value.timeAttribute.fill"
            style="position:relative; padding: 0 5px;"
            :class="{'star':item.value.timeAttribute.fill}"
          ></span>
          {{(parseInt(pindex) + 1) + '.'}}
          {{item.value.timeAttribute.name}}
          <!-- 文件附件 -->

          <file
            style="display:inline;"
            v-if="item.value.timeAttribute.imageUrls.length != '0'"
            :item="item"
          ></file>
        </div>

        <div class="info_message">{{item.value.timeAttribute.prompt}}</div>
        <div class="time_content">
          <TimePicker
            v-model="item.value.timeAttribute.answer"
            format="HH:mm"
            placeholder="小时：分钟"
            style="width: 200px"
            :transfer="true"
          ></TimePicker>
          <!-- <el-time-select 
            placeholder="小时：分钟"  
            :picker-options="{
              start: '00:15',
              step: '00:15',
              end: '24: 00'
            }"
            :editable="false"  
            v-model="item.value.timeAttribute.answer" 
            style="width: 200px">
          </el-time-select>-->
          <!-- @click.native="showTimePicker(item, pindex)"  -->
        </div>

        <div
          class="parseValue"
          v-if="questionIsAnswer && item.value.timeAttribute.isParse"
        >{{item.value.timeAttribute.parseValue}}</div>
      </div>

      <!--日期时间题 -->
      <div class="time_select" v-if="item.type == 'DateTimeQuestion'">
        <div class="isTitle" v-if="item.value.dateTimeAttribute.isTitle">
          <span v-html="item.value.dateTimeAttribute.titleValue"></span>
        </div>
        <div class="time_title title_margin">
          <span
            v-if="item.value.dateTimeAttribute.fill"
            style="position:relative; padding: 0 5px;"
            :class="{'star':item.value.dateTimeAttribute.fill}"
          ></span>
          {{(parseInt(pindex) + 1) + '.'}}
          {{item.value.dateTimeAttribute.name}}
          <!-- 文件附件 -->

          <file
            style="display:inline;"
            v-if="item.value.dateTimeAttribute.imageUrls.length != '0'"
            :item="item"
          ></file>
        </div>

        <div class="info_message">{{item.value.dateTimeAttribute.prompt}}</div>
        <div class="time_content">
          <!-- <TimePicker
            v-model="item.value.dateTimeAttribute.answer"
            format="HH:mm"
            placeholder="小时：分钟"
            style="width: 200px"
          ></TimePicker>-->
          <dateTimePick :item="item" :pindex="pindex"></dateTimePick>
        </div>

        <div
          class="parseValue"
          v-if="questionIsAnswer && item.value.dateTimeAttribute.isParse"
        >{{item.value.dateTimeAttribute.parseValue}}</div>
      </div>

      <!-- 单选 -->
      <div v-if="item.type == 'SingleChoiceQuestion'">
        <div class="isTitle" v-if="item.value.singleChoiceAttribute.isTitle">
          <span v-html="item.value.singleChoiceAttribute.titleValue"></span>
        </div>
        <div class="multiple_title title_margin">
          <span
            v-if="item.value.singleChoiceAttribute.fill"
            style="position:relative; padding: 0 5px;"
            :class="{'star':item.value.singleChoiceAttribute.fill}"
          ></span>
          {{(parseInt(pindex) + 1) + '.'}}
          {{item.value.singleChoiceAttribute.name}}
          <!-- 文件附件 -->
          <file
            style="display:inline;"
            v-if="item.value.singleChoiceAttribute.imageUrls.length != '0'"
            :item="item"
          ></file>
        </div>

        <!-- 备注 -->
        <div class="full_info info_message">{{item.value.singleChoiceAttribute.prompt}}</div>
        <!-- 选项和内容 -->
        <radio
          :item="item"
          :pindex="pindex"
          @radiootherPrompt="radiootherPrompt"
          @Radiovalue="Radiovalue "
        ></radio>

        <div
          class="parseValue"
          v-if="questionIsAnswer && item.value.singleChoiceAttribute.isParse"
        >{{item.value.singleChoiceAttribute.parseValue}}</div>
      </div>
      <!-- 量表题 -->
      <div class="number_form" v-if="item.type == 'ScaleQuestion'">
        <div class="isTitle" v-if="item.value.scaleAttribute.isTitle">
          <span v-html="item.value.scaleAttribute.titleValue"></span>
        </div>
        <div class="form_title title_margin">
          <span
            v-if="item.value.scaleAttribute.fill"
            style="position:relative; padding: 0 5px;"
            :class="{'star':item.value.scaleAttribute.fill}"
          ></span>
          {{(parseInt(pindex) + 1) + '.'}}
          {{item.value.scaleAttribute.name}}
          <!-- 文件附件 -->
          <file
            style="display:inline;"
            v-if="item.value.scaleAttribute.imageUrls.length != '0'"
            :item="item"
          ></file>
        </div>

        <div class="info_message">{{item.value.scaleAttribute.prompt}}</div>
        <scale :item="item" :pindex="pindex" @scaleDate="scaleDate"></scale>

        <div
          class="parseValue"
          v-if="questionIsAnswer && item.value.scaleAttribute.isParse"
        >{{item.value.scaleAttribute.parseValue}}</div>
      </div>
      <!-- 多选题 -->
      <div class="multiple_choice" v-if="item.type == 'MultipleChoiceQuestion'">
        <div class="isTitle" v-if="item.value.multipleChoiceAttribute.isTitle">
          <span v-html="item.value.multipleChoiceAttribute.titleValue"></span>
        </div>
        <div class="multiple_title title_margin">
          <span
            v-if="item.value.multipleChoiceAttribute.fill"
            style="position:relative; padding: 0 5px;"
            :class="{'star':item.value.multipleChoiceAttribute.fill}"
          ></span>
          {{(parseInt(pindex) + 1) + '.'}}
          {{item.value.multipleChoiceAttribute.name}}
          {{item.value.multipleChoiceAttribute.minChoiceQuantity ? '（最少选' + item.value.multipleChoiceAttribute.minChoiceQuantity + '选项）' : ''}}
          {{item.value.multipleChoiceAttribute.maxChoiceQuantity ? '（最多选' + item.value.multipleChoiceAttribute.maxChoiceQuantity + '选项）' : ''}}
          <!-- 文件附件 -->
          <file
            style="display:inline;"
            v-if="item.value.multipleChoiceAttribute.imageUrls.length != '0'"
            :item="item"
          ></file>
        </div>

        <div class="info_message">{{item.value.multipleChoiceAttribute.prompt}}</div>
        <checkbox :item="item" :pindex="pindex" @checkboxDate="checkboxDate"></checkbox>

        <div
          class="parseValue"
          v-if="questionIsAnswer && item.value.multipleChoiceAttribute.isParse"
        >{{item.value.multipleChoiceAttribute.parseValue}}</div>
      </div>
      <!-- 下拉题 -->
      <div class="select_choice" v-if="item.type == 'DropDownQuestion'">
        <div class="isTitle" v-if="item.value.dropDownAttribute.isTitle">
          <span v-html="item.value.dropDownAttribute.titleValue"></span>
        </div>
        <!--  -->
        <div class="select_title title_margin">
          <span
            v-if="item.value.dropDownAttribute.fill"
            style="position:relative; padding: 0 5px;"
            :class="{'star':item.value.dropDownAttribute.fill}"
          ></span>
          {{(parseInt(pindex) + 1) + '.'}}
          {{item.value.dropDownAttribute.name}}
          <!-- 文件附件 -->
          <file
            style="display:inline;"
            v-if="item.value.dropDownAttribute.imageUrls.length != '0'"
            :item="item"
          ></file>
        </div>

        <div class="info_message">{{item.value.dropDownAttribute.prompt}}</div>
        <select-option :item="item" @selectDate="selectDate"></select-option>

        <div
          class="parseValue"
          v-if="questionIsAnswer && item.value.dropDownAttribute.isParse"
        >{{item.value.dropDownAttribute.parseValue}}</div>
      </div>
      <!-- 填空题  @focus="fullBlank(item, pindex)"-->
      <div class="full_blank" v-if="item.type == 'FillInBlankQuestion'">
        <div class="isTitle" v-if="item.value.fillInBlanksAttribute.isTitle">
          <span v-html="item.value.fillInBlanksAttribute.titleValue"></span>
        </div>
        <div class="full_title title_margin">
          <file
            style="display:inline;"
            v-if="item.value.fillInBlanksAttribute.imageUrls.length != '0'"
            :item="item"
            :pindex="pindex"
          ></file>
        </div>
        <!-- 文件附件 -->
        <div class="full_info info_message">{{item.value.fillInBlanksAttribute.prompt}}</div>
        <fill-blank :item="item" :pindex="pindex"></fill-blank>

        <div
          class="parseValue"
          v-if="questionIsAnswer && item.value.fillInBlanksAttribute.isParse"
        >{{item.value.fillInBlanksAttribute.parseValue}}</div>
      </div>
      <!-- 单文本  @change="textMessage(item, pindex)"-->
      <div class="single_text" v-if="item.type == 'SingleLineTextQuestion'">
        <div class="isTitle" v-if="item.value.singleLineTextAttribute.isTitle">
          <span v-html="item.value.singleLineTextAttribute.titleValue"></span>
        </div>
        <div class="text_title title_margin">
          <span
            v-if="item.value.singleLineTextAttribute.fill"
            style="position:relative; padding: 0 5px;"
            :class="{'star':item.value.singleLineTextAttribute.fill}"
          ></span>
          {{(parseInt(pindex) + 1) + '.'}}
          {{item.value.singleLineTextAttribute.name}}
          <!-- 文件附件 -->
          <file
            style="display:inline;"
            v-if="item.value.singleLineTextAttribute.imageUrls.length != '0'"
            :item="item"
          ></file>
        </div>

        <div class="info_message">{{item.value.singleLineTextAttribute.prompt}}</div>
        <single-text :item="item"></single-text>

        <div
          class="parseValue"
          v-if="questionIsAnswer && item.value.singleLineTextAttribute.isParse"
        >{{item.value.singleLineTextAttribute.parseValue}}</div>
      </div>
      <!-- 多行文本 -->
      <!--   -->
      <div class="multiple_text" v-if="item.type == 'MultipleLineTextQuestion'">
        <div class="isTitle" v-if="item.value.multipleLineTextAttribute.isTitle">
          <span v-html="item.value.multipleLineTextAttribute.titleValue"></span>
        </div>
        <div class="textm_title title_margin">
          <span
            v-if="item.value.multipleLineTextAttribute.fill"
            style="position:relative; padding: 0 5px;"
            :class="{'star':item.value.multipleLineTextAttribute.fill}"
          ></span>
          {{(parseInt(pindex) + 1) + '.'}}
          {{item.value.multipleLineTextAttribute.name}}
          <!-- 文件附件 -->
          <file
            style="display:inline;"
            v-if="item.value.multipleLineTextAttribute.imageUrls.length != '0'"
            :item="item"
          ></file>
        </div>

        <div class="info_message">{{item.value.multipleLineTextAttribute.prompt}}</div>
        <multiple-text :item="item"></multiple-text>

        <div
          class="parseValue"
          v-if="questionIsAnswer && item.value.multipleLineTextAttribute.isParse"
        >{{item.value.multipleLineTextAttribute.parseValue}}</div>
      </div>

      <!-- 数字题   @change="digtalQuestion(item,pindex)"
      -->
      <div class="number_select" v-if="item.type == 'DigitalQuestion'">
        <div class="isTitle" v-if="item.value.digitalAttribute.isTitle">
          <span v-html="item.value.digitalAttribute.titleValue"></span>
        </div>
        <digital :item="item" :pindex="pindex"></digital>

        <div
          class="parseValue"
          v-if="questionIsAnswer && item.value.digitalAttribute.isParse"
        >{{item.value.digitalAttribute.parseValue}}</div>
      </div>

      <!-- 评分题 -->
      <div class="rate_select" style="width:100%;" v-if="item.type == 'RateQuestion'">
        <div class="isTitle" v-if="item.value.rateAttribute.isTitle">
          <span v-html="item.value.rateAttribute.titleValue"></span>
        </div>
        <div class="rate_title title_margin" style="width:100%;">
          <span
            v-if="item.value.rateAttribute.fill"
            style="position:relative; padding: 0 5px;"
            :class="{'star':item.value.rateAttribute.fill}"
          ></span>
          {{(parseInt(pindex) + 1) + '.'}}
          {{item.value.rateAttribute.name}}
          <!-- 文件附件 -->
          <file
            style="display:inline;"
            v-if="item.value.rateAttribute.imageUrls.length != '0'"
            :item="item"
          ></file>
        </div>

        <div class="info_message">{{item.value.rateAttribute.prompt}}</div>
        <rate :item="item" :pindex="pindex"></rate>

        <div
          class="parseValue"
          v-if="questionIsAnswer && item.value.rateAttribute.isParse"
        >{{item.value.rateAttribute.parseValue}}</div>
      </div>

      <!-- 上传文件 -->
      <div class="file_select" v-if="item.type == 'FileUploadQuestion'">
        <div class="isTitle" v-if="item.value.fileUploadAttribute.isTitle">
          <span v-html="item.value.fileUploadAttribute.titleValue"></span>
        </div>
        <div class="file_title title_margin">
          <span
            v-if="item.value.fileUploadAttribute.fill"
            style="position:relative; padding: 0 5px;"
            :class="{'star':item.value.fileUploadAttribute.fill}"
          ></span>
          {{(parseInt(pindex) + 1) + '.'}}
          {{item.value.fileUploadAttribute.name}}
          {{item.value.fileUploadAttribute.singleFileKBytes ? '(单个文件最大' + item.value.fileUploadAttribute.singleFileKBytes + 'kb)': ''}}
          {{item.value.fileUploadAttribute.maxFileQuantity ? '(最多上传' + item.value.fileUploadAttribute.maxFileQuantity + '个文件)': ''}}
          {{item.value.fileUploadAttribute.fileType ? '(上传文件类型' + item.value.fileUploadAttribute.fileType + ')': ''}}
          <file
            style="display:inline;"
            v-if="item.value.fileUploadAttribute.imageUrls.length != '0'"
            :item="item"
          ></file>
        </div>
        <!-- 文件附件 -->
        <div class="info_message">{{item.value.fileUploadAttribute.prompt}}</div>
        <upload :item="item" :newDom="newDom"></upload>

        <div
          class="parseValue"
          v-if="questionIsAnswer && item.value.fileUploadAttribute.isParse"
        >{{item.value.fileUploadAttribute.parseValue}}</div>
      </div>

      <!-- 滑块题 -->
      <div class="rate_select" v-if="item.type == 'SliderQuestion'">
        <div class="isTitle" v-if="item.value.sliderAttribute.isTitle">
          <span v-html="item.value.sliderAttribute.titleValue"></span>
        </div>
        <div class="rate_title title_margin">
          <span
            v-if="item.value.sliderAttribute.fill"
            style="position:relative; padding: 0 5px;"
            :class="{'star':item.value.sliderAttribute.fill}"
          ></span>
          {{(parseInt(pindex) + 1) + '.'}}
          {{item.value.sliderAttribute.name}}
          <!-- 文件附件 -->
          <file
            style="display:inline;"
            v-if="item.value.sliderAttribute.imageUrls.length != '0'"
            :item="item"
          ></file>
        </div>

        <div class="info_message">{{item.value.sliderAttribute.prompt}}</div>
        <slider :item="item" :pindex="pindex"></slider>

        <div
          class="parseValue"
          v-if="questionIsAnswer && item.value.sliderAttribute.isParse"
        >{{item.value.sliderAttribute.parseValue}}</div>
      </div>

      <!-- 表格 -->
      <div class="rate_select" v-if="item.type == 'TableQuestion'">
        <div class="isTitle" v-if="item.value.tableAttribute.isTitle">
          <span v-html="item.value.tableAttribute.titleValue"></span>
        </div>
        <div class="rate_title title_margin">
          <span
            v-if="item.value.tableAttribute.fill"
            style="position:relative; padding: 0 5px;"
            :class="{'star':item.value.tableAttribute.fill}"
          ></span>
          {{(parseInt(pindex) + 1) + '.'}}
          {{item.value.tableAttribute.name}}
          <!-- 文件附件 -->
          <file
            style="display:inline;"
            v-if="item.value.tableAttribute.imageUrls.length != '0'"
            :item="item"
          ></file>
        </div>

        <div class="info_message">{{item.value.tableAttribute.prompt}}</div>

        <table-text :item="item" :pindex="pindex"></table-text>

        <div
          class="parseValue"
          v-if="questionIsAnswer && item.value.tableAttribute.isParse"
        >{{item.value.tableAttribute.parseValue}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import slider from './questionComponents/slider'
import tableText from './questionComponents/table'
import rate from './questionComponents/rate'
import radio from './questionComponents/radio'
import checkbox from './questionComponents/checkbox'
import fillBlank from './questionComponents/fillBlank'
import scale from './questionComponents/scale'
import file from './questionComponents/file'
import upload from './questionComponents/upload'
import selectOption from './questionComponents/select'
import digital from './questionComponents/digital'
import multipleText from './questionComponents/multipleText'
import datePick from './questionComponents/datePick'
import singleText from './questionComponents/singleText'
import { TimeSelect, DatePicker } from 'element-ui'

import dateTimePick from './questionComponents/dateTimePick'
export default {
  props: ['item', 'pindex', 'questionIsAnswer'],
  data() {
    return {
      // 时间
      timevalue: '',
      dataSelect: '',
      dateInfo: {
        begin_time: '',
        end_time: '',
      },
      startDate: '',
      endDate: '',
      // 量表题
      number_radio: '',
      numberRadioData: {},
      answer: {},
      maxWordQuantity: '',
      minWordQuantity: '',
      // 没有小数点
      // digitaStep:"any",
      maxValue: '',
      minValue: '',
      stepSpot: 0,
      pointSpot: -1,
      newDom: false,
    }
  },
  mounted: function () {
    console.log(this.questionIsAnswer)
  },
  methods: {
    // 单选从子组件获取的值
    // 需要其他选项的值
    radiootherPrompt: function (val) {
      // console.log("main:", val);

      // this.item.value.singleChoiceAttribute.answer = val
      this.$emit('radiootherPrompt', val)
    },
    // 多选题
    checkboxDate: function (val) {
      // console.log(val);
      this.$emit('checkboxDate', val)
    },
    Radiovalue: function (val) {
      // console.log(val);
      // this.item.value.singleChoiceAttribute.answer = val
    },

    // 量表题
    scaleDate: function (val) {
      this.$emit('scaleDate', val)
    },
    //  下拉
    selectDate: function (val) {
      this.$emit('selectDate', val)
    },

    // 日期插件
    showDatePicker: function (item, pindex) {},
    // 时间插件
    showTimePicker: function (item, pindex) {
      console.log(item)
    },
  },
  components: {
    radio,
    checkbox,
    fillBlank,
    scale,
    file,
    upload,
    selectOption,
    rate,
    digital,
    singleText,
    multipleText,
    datePick,
    'el-date-picker': DatePicker,
    'el-time-select': TimeSelect,
    slider,
    tableText,
    dateTimePick,
  },
  computed: {},
  watch: {},
}
</script>
<style lang="less" scoped>
.cube-picker-choose .cube-picker-confirm {
  color: red !important;
}
.cube-picker-choose .cube-picker-cancel {
  color: red !important;
}
/* 备注 */
.info_message {
  color: rgb(180, 193, 212);
  margin-bottom: 10px;
}
/* input背景颜色 */
.input_bgc {
  height: 33px;
  border: 1px solid rgb(220, 220, 220);
  border-radius: 5px;
  padding-left: 10px;
  box-sizing: border-box;
  background-color: rgb(246, 248, 252);
}
.border-bottom-1px:after {
  border: none;
}
.title_margin {
  margin: 15px 0;
  line-height: 20px;
}

/* 单选题 */
/deep/ .cube-radio-group .cube-radio {
  border: 1px solid rgb(220, 220, 220) !important;
  margin-bottom: 10px;
  height: 33px;
  border-radius: 5px;
  padding-left: 10px;
  background-color: rgb(246, 248, 252);
}
/deep/ .cube-radio-group .cube-radio.cube-radio_selected {
  border: 1px solid rgb(66, 134, 241) !important;
}
/* 多选 */
/* /deep/ .multiple_choice .cube-checkbox {
  border: 1px solid rgb(220, 220, 220) !important;
  margin-bottom: 10px;
  height: 33px;
  border-radius: 5px;
  padding-left: 10px;
  background-color: rgb(246, 248, 252);
}
/deep/ .multiple_choice .cube-checkbox.cube-checkbox_checked {
  border: 1px solid rgb(66, 134, 241) !important;
} */
.single_title,
.multiple_title,
.form_title,
.radioPic_title {
  position: relative;
  word-wrap: break-word;
  word-break: break-word;
}
/* .single_title::after,
.multiple_title::after,
.form_title::after,
.radioPic_title::after {
  content: "*";
  margin-left: 5px;
  color: #e64340;
  font-size: 20px;
  margin-top: 10px;
} */
.star::after {
  position: absolute;
  top: 2px;
  left: 0;
  content: '*';

  color: #e64340;
  font-size: 20px;
}
/deep/ .cube-radio_selected .cube-radio-ui {
  background-color: rgb(66, 134, 241) !important;
}

/* 多选题 */
/deep/ .cube-checkbox_checked .cube-checkbox-ui i {
  color: rgb(66, 134, 241) !important;
}
/deep/ .cube-checkbox_checked .cube-checkbox-input {
  height: 33px;
}
/* 下拉题 */
.select_choice {
  width: 100%;
}
.select_choice select {
  width: 100%;
}

/* 多行文本 */
.multiple_text textarea {
  width: 100%;
  height: 100px;
  resize: none;
  padding: 10px;
  box-sizing: border-box;
}
/* 量表题 */
.number_form .cube-radio-group {
  display: flex;
  justify-content: space-between;
  border: none;
}
/* 数字提 */
.number_select,
.check_number {
  position: relative;
}
.number_select i,
.check_number i {
  position: absolute;
  top: 6px;
  left: 5px;
}
.number_select input,
.check_number input {
  width: 100%;
  padding-left: 25px;
}
/* 评分提 */
.rate-item {
  width: 100%;
  height: 100%;
  background-size: 100%;
  background-color: grey;
}
.cube-rate .cube-rate-item_active img {
  background-color: orange;
}
.cube-rate-item img {
  width: 10px;
  height: 10px;
}
/* 上传文件 */
.uploadbtn {
  width: 100%;
  height: 33px;
  text-align: center;
  line-height: 35px;
  background-color: rgb(226, 232, 243);
  border: none;
  border: 1px solid rgb(220, 220, 220);
  border-radius: 5px;
  color: #566277;
  margin-top: 20px;
}
/* 量表题 */
/deep/.form_title .cube-radio-group .cube-radio {
  border: none;
}

/* 时间 */
.time_content input {
  padding: 0 10px;
}
.time_select .time_content input::-moz-placeholder {
  text-align: right;
}
.time_select .time_content input::-webkit-input-placeholder {
  text-align: right;
}
.time_select .time_content input:-ms-input-placeholder {
  text-align: right;
}
.time_select .time_content input::placeholder {
  text-align: right;
}
.isTitle {
  color: #566277;
  text-align: center;
  /* margin: 30px 10px 0 10px; */
  font-size: 18px;
  font-weight: bold;
  // border-radius: 5px 5px 0 0;
  background-color: #e2e8f3;
  padding: 20px 0;
}
.parseValue {
  width: 100%;
  line-height: 30px;
  background: #f3f3f3;
  margin: 10px 0;
  padding: 20px;
  border-radius: 5px;
}
</style>